import {
  FETCH_CURRENT_PLAN_SENT,
  FETCH_CURRENT_PLAN_SUCCEEDED,
  FETCH_CURRENT_PLAN_FAILED,
  SUBSCRIBE_WITH_STRIPE_SENT,
  SUBSCRIBE_WITH_STRIPE_SUCCEEDED,
  SUBSCRIBE_WITH_STRIPE_FAILED,
  SUSPEND_SUBSCRIPTION_SENT,
  SUSPEND_SUBSCRIPTION_SUCCEEDED,
  SUSPEND_SUBSCRIPTION_FAILED,
  REACTIVATE_SUBSCRIPTION_SENT,
  REACTIVATE_SUBSCRIPTION_SUCCEEDED,
  REACTIVATE_SUBSCRIPTION_FAILED,
  TRANSFER_SUBSCRIPTION_SENT,
  TRANSFER_SUBSCRIPTION_SUCCEEDED,
  TRANSFER_SUBSCRIPTION_FAILED,
  RENEW_SUBSCRIPTION_SENT,
  RENEW_SUBSCRIPTION_SUCCEEDED,
  RENEW_SUBSCRIPTION_FAILED,
  SUBSCRIBE_WITH_PAYPAL_SUCCEEDED,
} from '../../actions/payment';

const initialState = {
  activePayment: null,
  currentPlan: null,
  loadingCurrentPlan: false,
  mutatingSubscription: false,
};

export default function paymentReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_CURRENT_PLAN_SENT:
      return {
        ...state,
        loadingCurrentPlan: true,
      };
    case FETCH_CURRENT_PLAN_FAILED:
      return {
        ...state,
        loadingCurrentPlan: false,
      };
    case FETCH_CURRENT_PLAN_SUCCEEDED:
      return {
        ...state,
        loadingCurrentPlan: false,
        activePayment: payload.payment,
        currentPlan: payload.plan,
      };
    case SUBSCRIBE_WITH_STRIPE_SENT:
    case SUSPEND_SUBSCRIPTION_SENT:
    case REACTIVATE_SUBSCRIPTION_SENT:
    case TRANSFER_SUBSCRIPTION_SENT:
    case RENEW_SUBSCRIPTION_SENT:
      return {
        ...state,
        mutatingSubscription: true,
      };
    case SUBSCRIBE_WITH_STRIPE_FAILED:
    case SUSPEND_SUBSCRIPTION_FAILED:
    case REACTIVATE_SUBSCRIPTION_FAILED:
    case TRANSFER_SUBSCRIPTION_FAILED:
    case RENEW_SUBSCRIPTION_FAILED:
      return {
        ...state,
        mutatingSubscription: false,
      };
    case SUBSCRIBE_WITH_STRIPE_SUCCEEDED:
    case SUSPEND_SUBSCRIPTION_SUCCEEDED:
    case REACTIVATE_SUBSCRIPTION_SUCCEEDED:
    case TRANSFER_SUBSCRIPTION_SUCCEEDED:
    case RENEW_SUBSCRIPTION_SUCCEEDED:
      return {
        ...state,
        mutatingSubscription: false,
        activePayment: payload.payment,
        currentPlan: payload.plan,
      };
    case SUBSCRIBE_WITH_PAYPAL_SUCCEEDED:
      return {
        ...state,
        activePayment: payload.payment,
        currentPlan: payload.plan,
      };
    default:
      return state;
  }
}
